/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 36,
  image: "default-changelog-v2.png",
  title: "Spheron Terraform Provider, Platform Improvements & Fixes",
  shortDescription: "We have published a Terraform provider. Released a new version of the Spheron Platform",
  description: "We have published a Terraform provider. Released a new version of the Spheron Platform",
  date: "June 30th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Terraform"]
};
export const content = `

## Platform Improvements & Fixes

- **Deployment Environment Branches:** We have enhanced the user experience for editing deployment environment branches, making it more user-friendly and intuitive.
- **Loader Issues:** We have addressed and resolved several issues related to loaders getting stuck or failing to work properly.
- **Time-out Deployments Count:** The issue where the count of timed-out deployments was not being displayed has been resolved.
- **Password Protection:** We have updated the logo on the password protection login page for a refreshed look.

## Compute Dashboard Enhancements

- **Instance Provider Enhancement:** To ensure the reliability of deployments, we have implemented additional restrictions that limit instance deployment to trusted Compute providers.
- **Price Display Issue:** We have fixed the problem where the price was not being displayed correctly when refreshing the page.
- **Instance Storage Clarity:** For better clarity, we have introduced labels in various locations to indicate whether the selected instance storage is ephemeral or persistent.

## ✨ Spheron Terraform Provider

We are thrilled to introduce our new product, the Spheron Terraform Provider! This new addition to our suite of tools offers you greater control and accessibility over your infrastructure on the Spheron platform.

With the Spheron Terraform Provider, managing your Spheron resources is now easier than ever. From deploying applications from the marketplace to launching instances, maintaining them, or linking them to domains, all of this is achievable programmatically through a Terraform resource block. Security is a top priority, and your access token remains secure and under your control in your backend server. This ensures that you have complete control over who can perform these operations using your token.

### Getting Started

To begin using the Spheron Terraform Provider, please refer to our comprehensive [documentation](https://docs.spheron.network/terraform/). This guide contains all the necessary information regarding prerequisites, installation, configuration, and usage. The complete code for the provider can be found on the Terraform Registry [here](https://registry.terraform.io/providers/spheronFdn/spheron/latest).

Embrace the power of Spheron Compute in a more automated and efficient way with the Spheron Terraform Provider! Enjoy the full potential of infrastructure-as-code with Spheron and Terraform! 🚀

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
